<template>
	<div>
		<template v-for="dia in dias">
			<div class="event-day" style="height: 30px;line-height: 30px;font-size: 16px;">
				{{ dia.data }}
			</div>
			<div v-for="campeonato in dia.campeonatos">
				<div class="event-championship" style="height: 30px;line-height: 30px;font-size: 16px;">
					{{ campeonato.nome }}
				</div>
				<div v-for="evento in campeonato.eventos" class="event" style="border-bottom: 0.5px solid #bfb5b5;">
					<div class="md-layout md-gutter md-alignment-center-center">
					    <div class="md-layout-item md-size-15 event-hour" style="font-size: 1em !important;">{{ evento.horario }}</div>
					    <div class="md-layout-item event-name md-size-70">
					    	<div class="md-layout md-gutter" style="padding-top: 5px;padding-bottom: 5px;">
					    		<div class="md-layout-item md-size-45" style="line-height: 1.3; font-size: 1.3em !important;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;">{{ evento.casa }}</div>
					    		<div class="md-layout-item md-size-10" style="font-size: 1.1em !important;">X</div>
					    		<div class="md-layout-item md-size-45" style="line-height: 1.3; font-size: 1.3em !important;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;">{{ evento.fora }}</div>
					    	</div>
						</div>
					    <div style="cursor: pointer;" class="md-layout-item event-icon md-size-15" v-on:click="detail(evento.id)"><md-icon >arrow_forward_ios</md-icon></div>
				  	</div>
				  	<div class="md-layout-item md-size-100">
						<div class="md-layout md-gutter event-line-odd" style="margin-bottom: 2px;">
				  			<div v-for="subevento in evento.subeventos.slice(0, 5)" class="md-layout-item md-alignment-center-center event-odd" style="font-size: 11pt;text-align: center; border-radius: 5px; height: 100%; margin-bottom: 2px;">
				  				<table class="event-tb-odd" cellspacing="0" cellpadding="0" v-bind:class="verifyClass(subevento)" v-on:click="select(dia.data, evento, subevento)" style="font-size: 14px;text-align: center; border-radius: 5px;">
				  					<tr>
				  						<td> {{ subevento.nome }} </td>
				  					</tr>
				  					<tr>
				  						<td> {{ subevento.cotacao }} </td>
				  					</tr>
				  				</table>
				  			</div>
				  		</div>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>
<script>

	import axios from 'axios'

	export default {
		name: 'TitanEvents',
		props: ['dias', 'selected'],
		data () {
			return {
			}
		},
		// define métodos dentro do objeto `methods`
		methods: {
			select: function (dia, evento, subevento) {

				if (subevento.cotacao <= 1) return false;

				subevento.evento = evento
				subevento.dia = dia

				let exists = false;
				for (let i = 0; i < this.selected.length; i++) {
					if (this.selected[i].evento.id == evento.id) {
						if (this.selected[i].id == subevento.id) this.selected.splice(i, 1);
						else {
							this.selected.splice(i, 1, subevento);
						}
						exists = true;
					}
				}

				if (!exists) {
					this.selected.push(subevento);
				}

				this.$emit('select', this.selected)
			},
			disableSubevento: function(subevento){
				return subevento.cotacao <= 1
			},
			isSelected: function(subevento) {
				let isSelected = false;
				for (let i = 0; i < this.selected.length; i++) {
					if (this.selected[i].id == subevento.id) isSelected = true;
				}

				return isSelected;
			},
			verifyClass: function(subevento) {
				return {
					'odd-disabled': this.disableSubevento(subevento),
					'odd-selected': this.isSelected(subevento)
				}
			},
			detail: function(event_id) {
				axios
				.get(this.$root.$data.API_URL + 'event/' + event_id)
				.then(response => {
					this.$emit('eventDetail', response.data)
		        })
				.finally(() => this.loadingEvents = false );
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/TitanEvents.vue